(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/polling-desktop.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/polling-desktop.js');


'use strict';

const Button = svs.ui.Button;
const Loader = svs.components.ReactLoader.Loader;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom;
const isPollingAtom = svs.iam_idp.atoms.isPollingAtom;
const isPnp = svs.iam_idp.data.isPnp;
const PollingDesktop = () => {
  const setIsPolling = useSetAtom(isPollingAtom);
  return React.createElement("div", null, React.createElement("div", {
    className: "spinner-container"
  }, React.createElement("p", {
    className: "spinner-container-text"
  }, "V\xE4ntar p\xE5 identifiering i app"), React.createElement(Loader, {
    inverted: !isPnp
  })), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      svs.accountservices.authenticate.login.cancel();
      setIsPolling(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_idp.components.shared.PollingDesktop = PollingDesktop;

 })(window);